import { Img } from 'openimg/react'
import { Avatar, AvatarFallback } from '#app/components/ui/avatar.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { cn, getUserImgSrc } from '#app/utils/misc.tsx'

type UserAvatarProps = {
	objectKey?: string | null
	name?: string | null
	username?: string | null
	className?: string
	width?: number
	height?: number
	isAboveFold?: boolean
}

/** First letters of up to two words, uppercased: "Ada Lovelace" → "AL". */
function getInitials(label: string) {
	return label
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((word) => word[0]!.toUpperCase())
		.join('')
}

export function UserAvatar({
	objectKey,
	name,
	username,
	className,
	width = 256,
	height = 256,
	isAboveFold,
}: UserAvatarProps) {
	const alt = name ?? username ?? ''
	return (
		// Initials scale with the circle, from the 32px dropdown to the 208px profile.
		<Avatar className={cn('@container', className)}>
			{/*
				openimg's Img rather than AvatarImage: Radix renders its image only
				after a client-side preload, which would lose the server-rendered img,
				the resized srcset and lazy loading.
			*/}
			{objectKey ? (
				<Img
					src={getUserImgSrc(objectKey)}
					alt={alt}
					width={width}
					height={height}
					isAboveFold={isAboveFold}
					className="size-full object-cover"
				/>
			) : (
				<AvatarFallback
					className="text-[40cqw]"
					role="img"
					aria-label={alt || undefined}
					aria-hidden={alt ? undefined : true}
				>
					{alt ? (
						getInitials(alt)
					) : (
						<Icon name="avatar" className="size-full" />
					)}
				</AvatarFallback>
			)}
		</Avatar>
	)
}
